import { useEffect } from 'react';
import {
  EntityListProvider,
  useEntityList,
} from '@mainstage/plugin-catalog-react';
import { CatalogTable } from '@agilelab/plugin-wb-builder-catalog';
import { PracticeShaperFilters } from '@agilelab/plugin-wb-practice-shaper';
import {
  WbCardContent,
  UserListPicker as FavouritesPicker,
  EntityUserFilter,
} from '@agilelab/plugin-wb-platform';
import { Paper } from '@material-ui/core';

const InitializeFilter = () => {
  const { updateFilters } = useEntityList<PracticeShaperFilters>();

  useEffect(() => {
    const filters: Partial<PracticeShaperFilters> = {
      kindList: new EntityUserFilter(),
    };
    updateFilters(filters);
  }, [updateFilters]);

  return null;
};

export const UserPage = () => {
  return (
    <EntityListProvider pagination={{ limit: 25 }}>
      <Paper style={{ height: '100%' }}>
        <WbCardContent style={{ paddingBottom: 0 }}>
          <InitializeFilter />
          <CatalogTable
            preUrl="/platform-settings"
            columnKind="user"
            filtersNode={
              <>
                <FavouritesPicker />
              </>
            }
            limit={25}
          />
        </WbCardContent>
      </Paper>
    </EntityListProvider>
  );
};
